module.exports = __webpack_public_path__ + "thumbnail-efd295f3e09152b72dea5604a834c529.png";